import { useState } from 'react';
import { Link } from 'react-router-dom';
import logoImg from '@/assets/images/logo.png';
import { useAuth } from '../../context/AuthContext'; // 引入 AuthContext

export default function Navbar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { isAuthenticated } = useAuth(); // 取得登入狀態

  return (
    <header className="fixed top-0 left-0 right-0 z-50 transition-all duration-500 bg-white/95 backdrop-blur-md shadow-sm">
      <nav className="w-full px-4 md:px-8 lg:px-12">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 group cursor-pointer">
            <div className="w-8 h-8 md:w-9 md:h-9 rounded-lg overflow-hidden flex items-center justify-center">
              <img src={logoImg} alt="Nice Game" className="w-full h-full object-contain" />
            </div>
            <span className="font-heading text-base md:text-lg font-semibold tracking-tight transition-colors duration-300 text-text-dark">
              Nice Game
            </span>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8">
            <Link to="/" className="text-sm font-medium transition-colors duration-300 hover:opacity-70 text-text-dark cursor-pointer whitespace-nowrap">
              首頁
            </Link>
            
            {/* 核心修正：根據登入狀態切換按鈕 */}
            {isAuthenticated ? (
              <Link
                to="/member"
                className="flex items-center gap-2 text-sm font-medium transition-colors duration-300 hover:opacity-70 text-text-dark cursor-pointer whitespace-nowrap"
              >
                <div className="w-7 h-7 rounded-full bg-star-black/10 flex items-center justify-center">
                  <i className="ri-user-line text-xs text-text-dark"></i>
                </div>
                會員中心
              </Link>
            ) : (
              <Link
                to="/login"
                className="flex items-center gap-2 text-sm font-medium transition-colors duration-300 hover:opacity-70 text-text-dark cursor-pointer whitespace-nowrap"
              >
                <div className="w-7 h-7 rounded-full bg-star-black/10 flex items-center justify-center">
                  <i className="ri-user-line text-xs text-text-dark"></i>
                </div>
                會員登入
              </Link>
            )}
          </div>

          {/* Mobile toggle */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden w-8 h-8 flex items-center justify-center cursor-pointer"
            aria-label="選單"
          >
            <i className={`text-xl text-text-dark ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-fog-mid">
            <div className="flex flex-col gap-3">
              <Link
                to="/"
                onClick={() => setMobileMenuOpen(false)}
                className="text-sm font-medium text-text-dark py-2 cursor-pointer"
              >
                首頁
              </Link>
              
              {/* 核心修正：手機版選單同樣根據狀態切換 */}
              {isAuthenticated ? (
                <Link
                  to="/member"
                  onClick={() => setMobileMenuOpen(false)}
                  className="flex items-center gap-2 text-sm font-medium text-text-dark py-2 cursor-pointer"
                >
                  <i className="ri-user-line"></i>
                  會員中心
                </Link>
              ) : (
                <Link
                  to="/login"
                  onClick={() => setMobileMenuOpen(false)}
                  className="flex items-center gap-2 text-sm font-medium text-text-dark py-2 cursor-pointer"
                >
                  <i className="ri-user-line"></i>
                  會員登入
                </Link>
              )}
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}